<div class="loader-wrap">
  <div class="background slide-top"></div>
  <div class="empty"></div>
  <div class="spinner d-flex flex-column justify-content-center slide-bottom">
    <div class="spinner-border text-primary align-self-end" role="status"></div>
  </div>
</div>
